module.exports = __webpack_public_path__ + "static/img/m-switcher-reservation-ui.b9c4b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/switcher/m-switcher-reservation-ui.png
// module id = SeHu
// module chunks = 1